import { CustomComponentProps } from "@repo/dynamicEditor/src/dynamicComponent/types";
import { SerializedFile } from "@repo/models";

import AgentPhoto from "./agentPhoto";
import AgentSummaryPhoto from "./agentSummaryPhoto";
import ComplaintCustomerActions from "./complaintCustomerActions";
import ComplaintLevel from "./complaintLevel";
import ComplaintSurveyGrid from "./complaintSurveyGrid";
import RepDisciplineHistoryGrid from "./disciplineHistoryGrid";
import { IndividualScore, Score } from "./fieldAudits";
import IncidentHistoryGrid from "./incidentHistoryGrid";
import { componentType } from "./portalDynamicComponent";
import PortalLink from "./portalLink";
import ReadOnlyDynamicEditor from "./readOnlyDynamicEditor";
import { FullProps, SpecificProps } from "./types";

/** Dynamic Components specific to Telemarketing application */
function PortalComponents(props: FullProps) {
	const { component } = props;

	function onUploadPhoto(photo: SerializedFile) {
		const values = [
			{ id: "rep.photoUrl", value: photo?.url },
			{ id: "rep.photo", value: photo },
		];
		props.valuesChanged(values);
	}

	switch (component.type as componentType) {
		case componentType.agentPhoto:
			return <AgentPhoto value={props.inputValue} onUpload={onUploadPhoto} readOnly={props.readOnly} />;
		case componentType.portalLink:
			return (
				<PortalLink
					name={component.label}
					entityId={component.propertyValue}
					entityType={component.component.value}
				/>
			);
		case componentType.complaintLevel:
			return <ComplaintLevel component={component} />;
		case componentType.disciplineHistories:
			return <RepDisciplineHistoryGrid />;
		case componentType.complaintHistories:
			return <IncidentHistoryGrid {...props} />;
		case componentType.complaintSurvey:
			return <ComplaintSurveyGrid {...props} />;
		case componentType.complaintCustomerActions:
			return <ComplaintCustomerActions {...props} />;
		case componentType.agentSummaryPhoto:
			return <AgentSummaryPhoto value={props.inputValue} />;
		case componentType.readOnlyDynamicEditor:
			return <ReadOnlyDynamicEditor {...props} />;
		case componentType.score:
			return <Score id={component.component.propertyName} repFieldAudit={props.repFieldAudit} />;
		case componentType.individualScore:
			return <IndividualScore id={component.component.propertyName} repFieldAudit={props.repFieldAudit} />;
		default:
			return null;
	}
}

export const getPortalComponents = (props: SpecificProps) => (componentProps: CustomComponentProps) => {
	return PortalComponents({ ...props, ...componentProps });
};
